import { Theme } from '@material-ui/core/styles';
import { TabClassKey } from '@material-ui/core/Tab';

const MuiTab = (theme: Theme): Partial<Record<TabClassKey, unknown>> => ({
    root: {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
    },
    textColorSecondary: {
        '&$selected': {
            color: theme.palette.secondary.dark,
        },
    },
});

export default MuiTab;
